import axios from 'axios'

//TODO move to env.file
const IMG_API_KEY = '80f906a0859603565f4da17d8613197f'
const IMG_END_POINT = `https://api.imgbb.com/1/upload?key=${IMG_API_KEY}`

export function uploadImage(formData) {
    return axios
        .post(`${IMG_END_POINT}`, formData, {
            headers: {'Content-Type': 'multipart/form-data'},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
